module.exports = __webpack_public_path__ + "img/Butterfly_00098.1eb6c085.png";